import {
  COMMISSION_STATUS,
  COMMISSION_CONFIG_STATUS,
  COMMISSION_RESULT_STATUS,
  COMMISSION_RESULT_VERDICT,
  PHASE,
  TERMINALS_LIST,
  COMMISSION_RESULT_FAIL_REASON,
  type RecommissionPrepareStepId,
} from '../utils/constants';

export type RecommissionPrepareStatus = 'idle' | 'in_progress' | 'success' | 'failed';

export interface RecommissionPrepareState {
  lastCompletedStepId: RecommissionPrepareStepId | null;
  progressPercent: number;
  stepMessage: string;
  status: RecommissionPrepareStatus;
}

export const DEFAULT_RECOMMISSION_PREPARE_STATE: RecommissionPrepareState = {
  lastCompletedStepId: null,
  progressPercent: 0,
  stepMessage: '',
  status: 'idle',
};

export interface CommissioningDevice {
  serialNumber: string;
  wifiStatus: {
    connected: boolean;
    ssid: string;
  };
  softwareUpdate: {
    needSoftwareUpdate: boolean;
    forceUpdate: boolean;
  };
  /**
   * Recommission eligibility from GET /commission/meter when code is 409.
   * null when the field is absent (non-409 responses) or after store reset.
   */
  userHasAccess: boolean | null;
  outputConnections: OutputConnections;
  terminalsStateFound: boolean;
  commissioningId: string | null;
  isUploadConfig: boolean;
  configUploadLog: ConfigUploadLog;
  commissioningLog: CommissionLog;
  commissionResultStatus: CommissionResultStatus;
  recommissionPrepare: RecommissionPrepareState;
}

export interface CommissionStateResponse {
  commissioning_id: string;
  state: string; // TODO: swap to COMMISSION_STATUS that's defined in another PR
  progress: {
    completed: number[];
  };
  phases: Record<PHASE, { miswired: boolean }> | Record<string, never>;
  connections: OutputConnections;
}

export interface ConfigUploadLog {
  status: COMMISSION_CONFIG_STATUS | null;
  startPercent?: number;
  text?: string;
}

export interface CommissionLog {
  status: COMMISSION_STATUS | null;
  startPercent?: number;
  text?: string;
}

export interface CommissionResultStatus {
  status: COMMISSION_RESULT_STATUS | null;
  startPercent?: number;
  text?: string;
  results?: CommissionResult | null;
}

export type CommissionResult = Record<
  Terminal,
  {
    verdict: COMMISSION_RESULT_VERDICT;
    reason?: COMMISSION_RESULT_FAIL_REASON;
  }
>;

export type Terminal = (typeof TERMINALS_LIST)[number];

/**
 * Object representing the reported connections of the device,
 * containing exactly 15 records, one for each Terminal (L1-1 to L3-5).
 *
 * For each terminal, we have the following information:
 * - ready: boolean, //true = Live connection detected, false = No connection
 * - state: string,  // 'DECOMMISSIONED', 'ERROR', 'TIMED_OUT' etc. For now we are not using it.
 */
export type OutputConnections = {
  [T in Terminal]: { ready: boolean; state: string };
};
